/**
 * Detects if the device is likely a TV or large screen
 */
export function isTVDevice() {
  // Check if it's a TV-like device based on user agent
  const ua = navigator.userAgent.toLowerCase();
  const isTv = 
    /smart-tv|smarttv|tv|android tv|google tv|roku|vizio|lg.?tv|samsung.?tv|philips.?tv|panasonic.?tv|hisense.?tv|sony.?tv/i.test(ua) ||
    /webos|tizen|vidaa|smartcast|netcast|aquos|bravia/i.test(ua);
  
  // Also check for browser request for desktop view (common on TV browsers)
  const prefersDesktop = 
    document.documentElement.clientWidth >= 1200 && 
    /mozilla|webkit|gecko/i.test(ua) && 
    !/mobile/i.test(ua);
  
  return isTv || prefersDesktop;
}

/**
 * Apply TV-specific classes to the document
 */
export function applyTVClasses() {
  if (isTVDevice()) {
    document.documentElement.classList.add('tv-device');
  }
}